import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon/default-profile.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-10 w-10",
  alt: ""
}, null, -1)
const _hoisted_2 = {
  class: "bg-white py-2 px-4 cursor-pointer rounded-lg border-gray-200 border-2",
  style: {"width":"190px"}
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "color-grey-5 font-semibold" }, "Ubah Password", -1)
const _hoisted_5 = { class: "flex items-center px-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "color-danger font-semibold" }, "Keluar", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvg = _resolveComponent("InlineSvg")!
  const _component_DropdownAbsolute = _resolveComponent("DropdownAbsolute")!

  return (_openBlock(), _createBlock(_component_DropdownAbsolute, { iconArrow: true }, {
    container: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", {
            class: "hover:text-yellow-500 mt-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePassword()))
          }, [
            _createElementVNode("li", _hoisted_3, [
              _createVNode(_component_InlineSvg, {
                src: require('@/assets/img/icon/lock-password.svg'),
                class: "w-5 h-5 mr-2"
              }, null, 8, ["src"]),
              _hoisted_4
            ])
          ]),
          _createElementVNode("ul", {
            class: "hover:text-yellow-500 mt-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
          }, [
            _createElementVNode("li", _hoisted_5, [
              _createVNode(_component_InlineSvg, {
                src: require('@/assets/img/icon/logout-red.svg'),
                class: "w-5 h-5 mr-2"
              }, null, 8, ["src"]),
              _hoisted_6
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}